import React, { Component } from 'react';
import { connect } from 'react-redux';
import { breadcrumbs } from '../../../../actions/appActions';
import { push } from 'react-router-redux';
import { isInternal } from '../../CroUtils';
import FinancialinstitutionsGrid from '../../components/grids/FinancialinstitutionsGrid';

class Financialinstitutions extends Component {
  componentWillMount() {
    this.props.breadcrumbs([{ label: 'Finanční instituce' }]);
  }

  onEdit = ({ id }) => {
    this.props.push(`${this.props.auth.startUrl}/financni-instituce/form/${id}`);
  }

  onAdd = () => {
    this.props.push(`${this.props.auth.startUrl}/financni-instituce/form`);
  }

  render() {
    const { auth } = this.props;

    return (
      <FinancialinstitutionsGrid
        gridName='financialinstitutionsGrid_all'
        url={`${auth.startUrl}/api/financni-instituce`}
        adding={isInternal(auth)}
        onAdd={this.onAdd}
        onRowClick={this.onEdit} />
    );
  }
}

export default connect(null, { breadcrumbs, push })(Financialinstitutions);
